import type { IconProps } from '@iconify/react';
import type { IconifyName } from './register-icons';

import { Icon } from '@iconify/react';
import { styled } from '@mui/material/styles';

import { allIconNames, registerIcons } from './register-icons';

// ----------------------------------------------------------------------

export type IconifyProps = React.ComponentProps<typeof IconRoot> &
  Omit<IconProps, 'icon'> & {
    /**
     * `string & {}` mantém o autocomplete dos ícones já embarcados sem travar quem acabou de escrever um nome novo — o
     * gerador embarca no `pnpm dev` e no commit, e derruba o commit se o nome não existir.
     */
    icon: IconifyName | (string & {});
  };

export function Iconify({ icon, width = 20, height, sx, ...other }: IconifyProps) {
  if (!(allIconNames as string[]).includes(icon)) {
    console.warn(`Ícone "${icon}" não está registrado. Copie o corpo dele para components/iconify/icon-sets.ts.`);
  }

  registerIcons();

  return (
    <IconRoot
      ssr
      icon={icon}
      sx={[
        {
          width,
          flexShrink: 0,
          height: height ?? width,
          display: 'inline-flex'
        },
        ...(Array.isArray(sx) ? sx : [sx])
      ]}
      {...other}
    />
  );
}

// ----------------------------------------------------------------------

const IconRoot = styled(Icon)``;
